import React from "react";
import ApplyHereRedesign from "../redesign/ApplyHereRedesign";

const ApplyHere = () => {
  return <ApplyHereRedesign />;
};

export default ApplyHere;
